import React, { useState } from 'react';
import {
  Button,
  TableCell,
  TableRow,
  Menu,
  MenuItem,
  IconButton
} from '@material-ui/core';
import { MoreVert } from '@material-ui/icons';
import { withStyles } from '@material-ui/core/styles';
import { TLedger } from '../../types/Ledger';
import { useRecoilState } from 'recoil';
import { btnColor } from '../../GlobalState';
import { useHistory } from 'react-router-dom';
import { DeleteModal } from '../DeleteModal';

const StyledTableCell = withStyles(theme => ({
  head: {
    backgroundColor: theme.palette.common.black,
    color: theme.palette.common.white
  },
  body: {
    fontSize: 16
  }
}))(TableCell);

const StyledTableRow = withStyles(theme => ({
  root: {
    '&:nth-of-type(odd)': {
      backgroundColor: theme.palette.action.hover,
      '&:hover': {
        backgroundColor: '#CFCFCF'
      }
    }
  }
}))(TableRow);

const isMobile: boolean = window.innerWidth < 920;

type Tprops = {
  index: number;
  ledger: TLedger;
  onDownload: any;
  onCopy: any;
  getList: any;
  onDelete: any;
};

export const List: React.FC<Tprops> = (props: Tprops) => {
  const { index, ledger, onDownload, onCopy, getList, onDelete } = props;

  const [buttonColor] = useRecoilState(btnColor);

  const history = useHistory();

  const [open, setOpen] = useState<boolean>(false);

  // スマホ対応時の、縦3点リーダーのメニュー
  const [menuAnchor, setMenuAnchor] = React.useState<null | HTMLElement>(null);
  const menuOpen = Boolean(menuAnchor);
  const handleMenuClick = (event: React.MouseEvent<HTMLElement>) => {
    setMenuAnchor(event.currentTarget);
  };
  const handleMenuClose = () => {
    setMenuAnchor(null);
  };

  return (
    <>
      <StyledTableRow className='click_table_row' key={index}>
        <StyledTableCell style={{ width: '30%' }} align='center'>
          {ledger.title}
        </StyledTableCell>
        <StyledTableCell style={{ width: '20%' }} align='center'>
          {ledger.created_at}
        </StyledTableCell>
        <StyledTableCell style={{ width: '10%' }} align='center'>
          {ledger.created_by}
        </StyledTableCell>
        <StyledTableCell style={{ width: '10%' }} align='center'>
          {ledger.count}
        </StyledTableCell>
        {isMobile ? (
          <StyledTableCell
            style={{
              width: '30%',
              paddingRight: '10%'
            }}
            align='left'
          >
            <IconButton id='long-button' onClick={handleMenuClick}>
              <MoreVert />
              <Menu
                id='long-menu'
                MenuListProps={{
                  'aria-labelledby': 'long-button'
                }}
                anchorEl={menuAnchor}
                open={menuOpen}
                onBlur={handleMenuClose}
              >
                <MenuItem
                  key={'ダウンロード'}
                  onClick={() => onDownload(ledger.id)}
                >
                  ダウンロード
                </MenuItem>
                <MenuItem
                  key={'コピー'}
                  onClick={async () => {
                    await onCopy(ledger.id);
                    await getList();
                  }}
                >
                  コピー
                </MenuItem>
                <MenuItem
                  key={'編集'}
                  onClick={() =>
                    history.push('/edit-ledger', {
                      constructId: ledger.construct_id,
                      photoLedgerId: ledger.id
                    })
                  }
                >
                  編集
                </MenuItem>
                <MenuItem key={'削除'} onClick={() => setOpen(true)}>
                  削除
                </MenuItem>
              </Menu>
            </IconButton>
            <DeleteModal
              open={open}
              setOpen={setOpen}
              title={'写真台帳'}
              onDelete={async () => {
                await onDelete(ledger.id);
                await getList();
                setOpen(false);
              }}
            />
          </StyledTableCell>
        ) : (
          <StyledTableCell style={{ width: '30%' }} align='center'>
            <Button
              style={{
                backgroundColor: buttonColor,
                color: '#fff',
                marginRight: 10
              }}
              variant='contained'
              color='secondary'
              onClick={() => onDownload(ledger.id)}
            >
              ダウンロード
            </Button>
            <Button
              style={{
                backgroundColor: buttonColor,
                color: '#fff',
                marginRight: 10
              }}
              variant='contained'
              color='secondary'
              onClick={async () => {
                await onCopy(ledger.id);
                await getList();
              }}
            >
              <span style={{ marginLeft: 8 }}>コピー</span>
            </Button>
            <Button
              style={{
                backgroundColor: buttonColor,
                color: '#fff',
                marginRight: 10
              }}
              variant='contained'
              color='secondary'
              onClick={() =>
                history.push('/edit-ledger', {
                  constructId: ledger.construct_id,
                  photoLedgerId: ledger.id
                })
              }
            >
              編集
            </Button>
            <Button
              style={{
                backgroundColor: buttonColor,
                color: '#fff',
                marginRight: 10
              }}
              variant='contained'
              color='secondary'
              onClick={() => setOpen(true)}
            >
              削除
            </Button>
            <DeleteModal
              open={open}
              setOpen={setOpen}
              title={'写真台帳'}
              onDelete={async () => {
                await onDelete(ledger.id);
                await getList();
              }}
            />
          </StyledTableCell>
        )}
      </StyledTableRow>
    </>
  );
};
